import { api } from './api';

export interface UpgradeResult {
  status: string;
  plan: string;
  trialEndsAt: null;
}

/**
 * End the free trial and switch to the paid plan. Payment is a placeholder for now — this simply
 * lifts the read-only lockout by flipping the workspace to active. Exempt from the trial write-block
 * server-side, so it works even while the trial is expired.
 */
export async function upgradeTrial(): Promise<UpgradeResult> {
  const res = await api.post<{ data: UpgradeResult }>('/billing/upgrade', {});
  return res.data.data;
}
